import { getData, setData } from '@/services/api'
import { rsort } from 'semver'
import Vue from 'vue'

let time_out = undefined

const state = () => ({
  stations_or_density: ['stations','','',''],
  selected_param: 1, // 1.- Conc. Oxígeno disuelto / 2.- % Oxígeno / 3.- Clorofila / 4.- Salinidad
  selected_param_compare: 0, // 1.- Conc. Oxígeno disuelto / 2.- % Oxígeno / 3.- Clorofila / 4.- Salinidad
  selected_depth: 0,
  available_depths: ['Fondo', 'Superficie'],
  campaign_datas: [],
  campaign_datas_filtered: [],
  selected_campaign_data: 0,
  legend_img: "",
  transect_status: 0, // 0.- Waiting / 1.- Drawing line on map (0 points selected) / 2.- Drawing line on map (1 point selected) / 3.- Calculating... / 4.- Graph received
  serie_status: 0, // 0.- Waiting / 1.- Drawing line on map (0 points selected) / 2.- Drawing line on map (1 point selected) / 3.- Calculating... / 4.- Graph received
  transect_points: [],
  show_graph_1: false,
  results_graph_1: [],
  results_graph_MM: [],
  conox_max_min_values: [0, 15],
  porox_max_min_values: [0, 200],
  cl_max_min_values: [0, 200],
  sal_max_min_values: [30, 56],
})

const mutations = {
  set_stations_or_density(state, data){
    switch (data) {
      case 'stations':
        if(state.stations_or_density[0] == 'stations')
          state.stations_or_density[0] =  ''
        else
          state.stations_or_density[0] = data
        break;
      case 'density':
        if(state.stations_or_density[1] == 'density')
          state.stations_or_density[1] = ''
        else
          state.stations_or_density[1] = data
        break;
      case 'transect':
        if(state.stations_or_density[2] == 'transect')
          state.stations_or_density[2] = ''
        else{
          state.stations_or_density[3] = ''
          state.transect_status = 0
          state.stations_or_density[2] = data
        }
        break;
      case 'serie_temp':
        if(state.stations_or_density[3] == 'serie_temp')
          state.stations_or_density[3] = ''
        else{
          state.stations_or_density[2] = ''
          state.serie_status = 0
          state.stations_or_density[3] = data
        }
        break;
    }  

    // Triñuela para hacer reactivo el array 
    state.stations_or_density.push('change')
    state.stations_or_density.pop()
  },
  set_selected_param(state, data){
    state.selected_param = data
  },
  set_selected_param_compare(state, data){
    state.selected_param_compare = data
  },
  set_selected_depth(state, data){
    state.selected_depth = data
  },
  set_campaign_datas(state, data){
    state.campaign_datas = data
    state.campaign_datas_filtered = data
  },
  set_campaign_datas_filtered(state, data) {
    state.campaign_datas_filtered = data
  },
  set_selected_campaign_data(state, data){
    state.selected_campaign_data = data
  },
  set_legend_img(state, data){
    state.legend_img = data
  },
  set_transect_status(state, data){
    state.transect_status = data
  },
  set_serie_status(state, data){
    state.serie_status = data
  },
  set_transect_points(state, data){
    state.transect_points = data
  },
  set_show_graph_1(state,data){
    state.show_graph_1 = data
  },
  set_results_graph_1(state,data){
    state.results_graph_1 = data
  },
  set_results_graph_MM(state,data){
    state.results_graph_MM = data
  }

}

const actions = {
  change_stations_or_density({ commit }, data) {
    commit("set_stations_or_density", data)
  },
  change_selected_param({ commit }, data) {
    commit("set_selected_param", data)
  },
  change_selected_param_compare({ commit }, data) {
    commit("set_selected_param_compare", data)
  },
  change_selected_depth({ commit }, data) {
    commit("set_selected_depth", data)
  },
  change_selected_campaign_data({ commit, getters, dispatch }, data) {
    commit("set_selected_campaign_data", data)

      
    if(getters['stations_or_density'][2] == 'transect' && getters['transect_points'].length == 2 && (getters['transect_status'] == 0 || getters['transect_status'] == 4)) {
      clearTimeout(time_out)
      time_out = setTimeout(() => {
        commit('set_transect_status', 3)
        dispatch('change_transect_points', getters['transect_points'])
      }, 2500);
      
    }     
    
    else {
      //console.log("Cant change campaign data right now")
    }
    
  },
  change_campaign_datas_filtered({ commit }, data) {
    commit("set_campaign_datas_filtered", data)
  },
  change_transect_status({ commit, getters }, data) {
    commit("set_transect_status", data)
  } ,
  change_serie_status({ commit, getters }, data) {
    commit("set_serie_status", data)
  } ,
  change_serie_temporal_MM({ commit, getters }, data) {
    //commit("set_serie_temporal_MM", data)
    let url = "mmdata/calc_serie_temporal_MM/"
    let from = new FormData();
    var id_list = []
    var dates_list = []
    getters['campaign_datas_filtered'].forEach(campaign => {
      id_list.push(campaign.id)
      dates_list.push(campaign.date)
    });

    from.append("selected_param", getters['selected_param'])
    from.append("id_list", JSON.stringify(id_list))
    from.append("dates_list", JSON.stringify(dates_list))


    setData(url,from)
    .then(res => {
      if(res.status == "200"){
        let results = {}
        results.dates = res.data.dates
        results.depth = res.data.depth
        results.values = res.data.values
        commit("set_results_graph_MM", results)
        commit("set_serie_status", 4)
      }else{
        commit("set_serie_status", 0)
      }
      
    })

  } ,
  change_serie_transect_points({ commit, getters }, data) {
    commit("set_transect_points", data)

    // comprobar que el punto esta dentro del mar menor    
    if(data.length == 2){
      if(data[0].lng > -0.87 && data[0].lng <-0.68 && data[1].lng > -0.87 && data[1].lng < -0.68 && data[0].lat > 37.6 && data[0].lat < 37.83 && data[1].lat > 37.6 && data[1].lat <37.83){
        let url = "mmdata/calc_serie_temporal_transect/"

        var id_list = []
        var dates_list = []
        let coordinates = new FormData();
        coordinates.append("lon_1", data[0].lng);
        coordinates.append("lat_1", data[0].lat);
        coordinates.append("lon_2", data[1].lng);
        coordinates.append("lat_2", data[1].lat);
        getters['campaign_datas_filtered'].forEach(campaign => {
          id_list.push(campaign.id)
          dates_list.push(campaign.date)
        });
    
        coordinates.append("selected_param", getters['selected_param'])
        coordinates.append("id_list", JSON.stringify(id_list))
        coordinates.append("dates_list", JSON.stringify(dates_list))
        
        setData(url,coordinates)
        .then(res => {
          if(res.status == "200"){
            let results = {}
            results.dates = res.data.dates
            results.depth = res.data.depth
            results.values = res.data.values
            commit("set_results_graph_MM", results)
            commit("set_serie_status", 4)
          }else{
            commit("set_serie_status", 0)
          }
    
        })
      }
    }  

  },
  change_transect_points({ commit, getters }, data) {
    commit("set_transect_points", data)

    // comprobar que el punto esta dentro del mar menor    
    if(data.length == 2){
      if(data[0].lng > -0.87 && data[0].lng <-0.68 && data[1].lng > -0.87 && data[1].lng < -0.68 && data[0].lat > 37.6 && data[0].lat < 37.83 && data[1].lat > 37.6 && data[1].lat <37.83){
        let url = "mmdata/calc_transect_1/"
        let coordinates = new FormData();
        
        coordinates.append("lon_1", data[0].lng);
        coordinates.append("lat_1", data[0].lat);
        coordinates.append("lon_2", data[1].lng);
        coordinates.append("lat_2", data[1].lat);
        coordinates.append("campaign_data_id", getters['campaign_datas_filtered'][getters['selected_campaign_data']].id);
        coordinates.append("selected_param", getters['selected_param'])
        commit("set_show_graph_1",false) 
        
        setData(url,coordinates)
        .then(res => {
          if(res.status == "200"){
            let results = {}
            results.depth = res.data.depth
            results.dist = res.data.dist
            results.values = res.data.values
            results.profs = res.data.profs
            results.dist_p = res.data.dist_p
            results.depth_p = res.data.depth_p
            commit("set_results_graph_1", results)
            commit("set_show_graph_1",true)
            // This timeout before displaying the graph tries to prevent not updating the graph extent when another transect is drawn. Weird... not an elegant solution... but seems to work.
            setTimeout(() => {
              commit("set_transect_status", 4)
            }, 250);
            
          }
          else {
            commit("set_transect_status", 0)
            Vue.noty.error('Se ha producido un error durante el cálculo')
          }
        })
      }
    }  

  },
  getCampaignDatas({ commit }) {
    let url = 'mmdata/params-campaign-datas/'
    getData(url).then(res=> {
      commit("set_campaign_datas", res.data.paramsCampaignDatas)
      //this.paramsCampaignsList = res.data.paramsCampaignDatas
      //this.paramsCampaignsListFiltered = res.data.paramsCampaignDatas.reverse()
    }) 
  },
  change_legend_img({ commit }, data) {
    commit("set_legend_img", data)
  },
  reset_results_transect_1({ commit }) {
    commit("set_results_graph_1", [])
    commit("set_transect_points", [])
    commit("set_transect_status", 0)
  },
  reset_results_serie_temp({ commit }) {
    commit("set_results_graph_MM", [])
    commit("set_serie_status", 0)
  }
}

const getters = {
  stations_or_density: state => state.stations_or_density,    
  selected_param: state => state.selected_param,
  selected_param_compare: state => state.selected_param_compare,
  selected_depth: state => state.selected_depth,
  available_depths: state => state.available_depths,
  campaign_datas: state => state.campaign_datas,
  campaign_datas_filtered: state => state.campaign_datas_filtered,
  selected_campaign_data: state => state.selected_campaign_data,
  get_legend_img: state => state.legend_img,
  transect_points: state => state.transect_points,
  show_graph_1: state => state.show_graph_1,
  results_graph_1: state => state.results_graph_1,
  results_graph_MM: state => state.results_graph_MM,
  transect_status: state => state.transect_status,
  serie_status: state => state.serie_status,
  conox_max_min_values: state => state.conox_max_min_values,
  porox_max_min_values: state => state.porox_max_min_values,
  cl_max_min_values: state => state.cl_max_min_values,
  sal_max_min_values: state => state.sal_max_min_values,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/map_params.js